
import {
  CHANGE_PAGE_SUCCESS, LOAD_RESPONSES_ERROR, LOAD_RESPONSES_REQUEST,
  LOAD_RESPONSES_SUCCESS
} from "./responses-action-types";

const initialState = {
  responses: {
    1: []
  },
  page: 1,
  totalPages: null,
  loading: false,
  error: '',
  whoMounted: null
};


export default ( state = initialState, action ) => {
  const { error, responses, page, totalPages, clean, whoMounted } = action;

  switch(action.type) {


    case CHANGE_PAGE_SUCCESS:
      return {
        ...state,
        page
      };

    case LOAD_RESPONSES_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
        whoMounted
      };

    case LOAD_RESPONSES_SUCCESS:
      if (clean) {
        return {
          ...state,
          loading: false,
          totalPages,
          page,
          error: "",
          responses: {
            1: responses
          }
        }
      }
      return {
        ...state,
        loading: false,
        totalPages,
        page,
        error: "",
        responses: {
          ...state.responses,
          [page]: responses
        }
      };

    case LOAD_RESPONSES_ERROR:
      return {
        ...state,
        loading: false,
        error
      };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/responses/responses-reducer.js